/** Fehlercodes im Feld `error` der Fehlerantwort (siehe ApiErrorBody, docs/API.md „Fehlerformat"). */
export const ErrorCodes = {
  VALIDATION_FAILED: 'VALIDATION_FAILED',
  UNAUTHORIZED: 'UNAUTHORIZED',
  TOKEN_EXPIRED: 'TOKEN_EXPIRED',
  INVALID_CREDENTIALS: 'INVALID_CREDENTIALS',
  ACCOUNT_DISABLED: 'ACCOUNT_DISABLED',
  REGISTRATION_CLOSED: 'REGISTRATION_CLOSED',
  FORBIDDEN: 'FORBIDDEN',
  MISSING_PERMISSIONS: 'MISSING_PERMISSIONS',
  MISSING_SCOPE: 'MISSING_SCOPE',
  NOT_FOUND: 'NOT_FOUND',
  CONFLICT: 'CONFLICT',
  USERNAME_TAKEN: 'USERNAME_TAKEN',
  EMAIL_TAKEN: 'EMAIL_TAKEN',
  VANITY_TAKEN: 'VANITY_TAKEN',
  LIMIT_REACHED: 'LIMIT_REACHED',
  PAYLOAD_TOO_LARGE: 'PAYLOAD_TOO_LARGE',
  UNSUPPORTED_MEDIA_TYPE: 'UNSUPPORTED_MEDIA_TYPE',
  RATE_LIMITED: 'RATE_LIMITED',
  SLOWMODE: 'SLOWMODE',
  BANNED: 'BANNED',
  INVITE_INVALID: 'INVITE_INVALID',
  CHANNEL_READONLY: 'CHANNEL_READONLY',
  THREAD_LOCKED: 'THREAD_LOCKED',
  DM_BLOCKED: 'DM_BLOCKED',
  BRIDGE_DISABLED: 'BRIDGE_DISABLED',
  SERVICE_UNAVAILABLE: 'SERVICE_UNAVAILABLE',
  INTERNAL: 'INTERNAL',
} as const;

export type ErrorCode = (typeof ErrorCodes)[keyof typeof ErrorCodes];
